import { useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import api, { clearToken, formatLoginError } from "../lib/api";
import AuthShell from "../components/AuthShell";
import { Input } from "../components/ui/input";
import { Button } from "../components/ui/button";
export default function ResetPassword() {
  const [params] = useSearchParams();
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const [done, setDone] = useState(false);
  const token = params.get("token");
  async function submit(e) {
    e.preventDefault(); setBusy(true); setError("");
    try { await api.post("/auth/reset-password", {token, password}); clearToken(); setDone(true); }
    catch (err) { setError(formatLoginError(err)); }
    finally { setBusy(false); }
  }
  return <AuthShell title="Choose a new password" subtitle="Secure your MonitorFlux account." footer={<Link to="/login">Back to sign in</Link>}>
    {done ? <p role="status">Password updated. Sign in again on your devices.</p> : !token ? <p role="alert">This reset link is incomplete. Request a new link from the sign-in page.</p> : <form onSubmit={submit} className="space-y-4"><label htmlFor="new-password">New password</label><Input id="new-password" type="password" autoComplete="new-password" minLength={8} required value={password} onChange={e=>setPassword(e.target.value)} /><p className="text-xs text-slate-500">Use at least 8 characters, including a letter and number.</p>{error && <p role="alert" className="text-red-600">{error}</p>}<Button disabled={busy} type="submit">{busy ? "Updating…" : "Save new password"}</Button></form>}
  </AuthShell>;
}
